import { useEffect } from 'react';
import { TRACKING_EVENTS } from './fueled.events';

export function FueledDataLayer() {
  // accumulate events until the fueled script is loaded
  useEffect(() => {
    const eventTypes = Object.values(TRACKING_EVENTS);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.packdigital = window.dataLayer?.packdigital || [];

    const eventHandler = (event) => {
      window.dataLayer.packdigital.push({
        type: event.type,
        detail: event.detail,
      });
    };

    eventTypes.forEach((eventType) =>
      window.addEventListener(eventType, eventHandler)
    );

    return () => {
      eventTypes.forEach((eventType) => {
        window.removeEventListener(eventType, eventHandler);
      });
    };
  }, []);

  return null;
}
